import logo from '../../../../assets/img/logo.png';

/**
 * @ngdoc controller
 * @name LoginController
 * @description
 * This component renders the Login section.
 *
 * @memberof account
 * @requires common
 */
class LoginController {
  /**
   * Class constructor.
   * @param {Service} $location              To redirect the user when the login process finishes.
   * @param {Object}  $rootScope             To broadcast the authorization events.
   * @param {Service} appUtils               To get the Admin accounts.
   * @param {Service} contentCreatorAdminAPI To send the login request.
   * @param {Object}  AUTH_EVENTS            To get the name of the events to be broadcasted.
   * @ignore
   */
  constructor(
    $location,
    $rootScope,
    appUtils,
    contentCreatorAdminAPI,
    AUTH_EVENTS,
  ) {
    'ngInject';

    /**
     * The local reference to the `$location` service.
     * @type {Object}
     */
    this.$location = $location;
    /**
     * The local reference to the `appUtils` service.
     * @type {Object}
     */
    this.appUtils = appUtils;
    /**
     * The local reference to the `$rootScope` object.
     * @type {Object}
     */
    this.$rootScope = $rootScope;
    /**
     * The local reference to the `contentCreatorAdminAPI` service.
     * @type {Object}
     */
    this.contentCreatorAdminAPI = contentCreatorAdminAPI;
    /**
     * The local reference to the `AUTH_EVENTS` constant.
     * @type {Object}
     */
    this.AUTH_EVENTS = AUTH_EVENTS;
    /**
     * The local reference to the `logo` image.
     * @type {String}
     */
    this.logo = logo;
    /**
     * The local reference to the `user` input value.
     * @type {String}
     */
    this.user = '';
    /**
     * The local reference to the `password` input value.
     * @type {String}
     */
    this.password = '';
    /**
     * To show an error if the user has not input any value.
     * @type {Boolean}
     */
    this.error = false;
    /**
     * To show an error or not for invalid user and password.
     * @type {Boolean}
     */
    this.invalidUserPassword = false;
  }
  /**
   * Handle the login action.
   */
  login() {
    this.invalidUserPassword = false;

    if (!this.user || !this.password) {
      this.error = true;
      return;
    }

    this.contentCreatorAdminAPI.login(this.user, this.password)
    .then((session) => {
      const accounts = this.appUtils.getAdminAccounts(session.accounts);

      // If no valid account is found, display error
      if (!accounts.length) {
        throw new Error();
      }

      this.$rootScope.$broadcast(this.AUTH_EVENTS.loginSuccess, session);
      this.$location.url('/');
    })
    .catch(() => {
      this.invalidUserPassword = true;
    });
  }
  /**
   * Handle the change of visibility of the password.
   */
  togglePassword() {
    this.showPassword = !this.showPassword;
  }
  /**
   * Handle if the form should display any error or not.
   */
  shouldDisplayError() {
    return this.invalidUserPassword
            || (
              this.error
                && (!this.user || !this.password)
            );
  }
}

export default LoginController;



// WEBPACK FOOTER //
// ./src/frontend/modules/account/components/login/login.controller.js